import { shallowEqual, useSelector } from "react-redux"

import type { RootState } from "./root.reducer"

export const useRootSelector = useSelector.withTypes<RootState>()

export function useShallowEqualSelector<R>(selector: (state: RootState) => R) {
  return useRootSelector(selector, shallowEqual)
}
